import { render, staticRenderFns } from "./StockExits.vue?vue&type=template&id=67af84f0&scoped=true"
import script from "./StockExits.vue?vue&type=script&lang=js"
export * from "./StockExits.vue?vue&type=script&lang=js"
import style0 from "./StockExits.vue?vue&type=style&index=0&id=67af84f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af84f0",
  null
  
)

export default component.exports